<app-close [outlet]="'modal'" testId="dialog-edit-student-close" />
<app-title tag="h2" tagStyle="h4" [title]="'students.edit.title' | translate" />

<form class="flex flex-col gap-6" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="flex gap-10 items-center">
        <app-avatar [avatarSrc]="student()?.avatarSrc" />

        <div class="flex gap-4 flex-col flex-1">
            <app-form-text
                class="flex-1"
                identifier="firstname"
                testId="students-edit-firstname"
                [label]="'students.edit.firstname.label' | translate"
                [placeholder]="'students.edit.firstname.placeholder' | translate"
                [control]="form.controls.firstName"
            />
            <app-form-text
                class="flex-1"
                identifier="lastname"
                testId="students-edit-lastname"
                [label]="'students.edit.lastname.label' | translate"
                [placeholder]="'students.edit.lastname.placeholder' | translate"
                [control]="form.controls.lastName"
            />
        </div>
    </div>

    <app-form-text
        identifier="email"
        testId="students-edit-email"
        [label]="'students.edit.email.label' | translate"
        [placeholder]="'students.edit.email.placeholder' | translate"
        [control]="form.controls.email"
    />

    <div>
        <legend>{{ 'label.role' | translate }}</legend>
        <div class="flex flex-wrap gap-x-4 gap-y-1">
            <app-form-radio
                [control]="form.controls.role"
                value="teacher"
                [label]="'role.teacher' | translate"
                name="create.role"
                identifier="create.role"
                testId="students-edit-role-teacher"
            />
            <app-form-radio
                [control]="form.controls.role"
                value="sna"
                [label]="'role.sna' | translate"
                name="create.role"
                identifier="create.role"
                testId="students-edit-role-sna"
            />
            <app-form-radio
                [control]="form.controls.role"
                value="leader"
                [label]="'role.leader' | translate"
                name="create.role"
                identifier="create.role"
                testId="students-edit-role-leader"
            />
            <app-form-radio
                [control]="form.controls.role"
                value="admin"
                [label]="'role.admin' | translate"
                name="create.role"
                identifier="create.role"
                testId="students-edit-role-admin"
            />
            <app-form-radio
                [control]="form.controls.role"
                value="individual"
                [label]="'role.individual' | translate"
                name="create.role"
                identifier="create.role"
                testId="students-edit-role-individual"
            />

            @if (student() && student()!.role === 'assessor') {
                <app-form-radio
                    [control]="form.controls.role"
                    value="assessor"
                    [label]="'role.assessor' | translate"
                    name="create.role"
                    identifier="create.role"
                    testId="students-edit-role-assessor"
                />
            }

            @if (student() && student()!.role === null) {
                <app-form-radio
                    [control]="form.controls.role"
                    [value]="null"
                    [label]="'role.unknown' | translate"
                    name="create.role"
                    identifier="create.role"
                    testId="students-edit-role-unknown"
                />
            }
        </div>
    </div>

    <app-form-submit [label]="'students.edit.button' | translate" [disabled]="form.disabled || updating()" testId="students-edit-submit" />
</form>
